/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BackgroundJobBatchResponse
 */
export interface BackgroundJobBatchResponse {
    /**
     * 
     * @type {string}
     * @memberof BackgroundJobBatchResponse
     */
    batchId?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof BackgroundJobBatchResponse
     */
    jobIds: Array<number>;
}

export function BackgroundJobBatchResponseFromJSON(json: any): BackgroundJobBatchResponse {
    return BackgroundJobBatchResponseFromJSONTyped(json, false);
}

export function BackgroundJobBatchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BackgroundJobBatchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'batchId': !exists(json, 'batch_id') ? undefined : json['batch_id'],
        'jobIds': json['job_ids'],
    };
}

export function BackgroundJobBatchResponseToJSON(value?: BackgroundJobBatchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'batch_id': value.batchId,
        'job_ids': value.jobIds,
    };
}

